import React from "react";
import { Landmark, Lock } from "lucide-react";
import { Button } from "../ui/button";
import { useGoCardlessMandate } from "../../hooks/useGoCardlessMandate";

const stageText: Record<string, string> = {
  opening: "Preparing secure connection…",
  in_modal: "Complete the bank details in the GoCardless window…",
  confirming: "Confirming your mandate with GoCardless…",
  active: "Direct Debit mandate active",
};

export function ConnectBankButton({ onActive, label = "Connect my bank account", className = "" }: { onActive?: () => void; label?: string; className?: string }) {
  const { start, stage, error, busy } = useGoCardlessMandate(onActive);
  return (
    <div className={className} data-testid="connect-bank">
      <Button onClick={start} disabled={busy || stage === "active"} className="w-full rounded-none py-6 text-base hover-lift" data-testid="connect-bank-button">
        <Landmark className="mr-2 h-4 w-4" strokeWidth={1.25} />
        {stage === "active" ? "Bank account connected" : busy ? stageText[stage] : label}
      </Button>
      {error && <p className="mt-3 text-sm text-[var(--wine)]" data-testid="connect-bank-error">{error}</p>}
      <p className="mt-3 flex items-center gap-2 text-xs text-neutral-500"><Lock className="h-3 w-3" strokeWidth={1.25} /> Bank details are entered directly with GoCardless and never touch our servers. Protected by the Direct Debit Guarantee.</p>
    </div>
  );
}
